<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="name" prop="name">
                <el-input v-model="queryCondition.name" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{ $t("common.search") }}</el-button>
            <el-button type="primary" @click="restQueryForm('queryCondition')">{{ $t("common.reset") }}</el-button>
          </el-row>
        </el-form>
        <div class="toolsBox">
          <el-button type="primary" @click="cronForm={},showSaveDialog=true">{{ $t('common.addNew') }}</el-button>
        </div>
        <el-table sortable :data="tableData" ref="tableList" border highlight-current-row class="table" row-key="tmGroupId">
          <el-table-column show-overflow-tooltip prop="serviceName" label="serviceName"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cron" label="cron"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="remark"></el-table-column>
          <el-table-column show-overflow-tooltip prop="name" label="name"></el-table-column>
          <el-table-column show-overflow-tooltip prop="lockMinuteMin" label="lockMinuteMin"></el-table-column>
          <el-table-column show-overflow-tooltip prop="lockMinuteMax" label="lockMinuteMax"></el-table-column>
          <el-table-column show-overflow-tooltip prop="disabledFlag" label="disabledFlag">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="method" label="method"></el-table-column>
          <el-table-column show-overflow-tooltip prop="leaderName" label="Action">
            <template slot-scope="scope">
              <el-button type="primary"  @click="showSaveDialog=true,cronForm=scope.row">Update</el-button>
              <el-button type="primary" @click="run(scope.row.id)">run</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--===分页组件===-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showSaveDialog" width="30%">
      <el-form v-if="showSaveDialog" :model="cronForm" ref="cronForm" class="cronForm" label-width="120px">
        <el-row>
          <el-col :span="20">
            <el-form-item label="serviceName" prop="groupName">
              <el-input clearable v-model.trim="cronForm.serviceName" class="handle-input"/>
            </el-form-item>
            <el-form-item label="cron" prop="groupName">
              <el-input clearable v-model.trim="cronForm.cron" class="handle-input"/>
            </el-form-item>
            <el-form-item label="remark" prop="groupName">
              <el-input clearable v-model.trim="cronForm.remark" class="handle-input"/>
            </el-form-item>
            <el-form-item label="name" prop="groupName">
              <el-input clearable v-model.trim="cronForm.name" class="handle-input"/>
            </el-form-item>
            <el-form-item label="lockMinuteMin" prop="groupName">
              <el-input clearable v-model.trim="cronForm.lockMinuteMin" class="handle-input"/>
            </el-form-item>
            <el-form-item label="lockMinuteMax" prop="groupName">
              <el-input clearable v-model.trim="cronForm.lockMinuteMax" class="handle-input"/>
            </el-form-item>
            <el-form-item label="disabledFlag" prop="groupName">
              <el-switch active-value="Y" inactive-value="N" v-model="cronForm.disabledFlag"></el-switch>
            </el-form-item>
            <el-form-item label="method" prop="groupName">
              <el-input clearable v-model.trim="cronForm.method" class="handle-input"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="categoryDetailDialog = false">{{ $t('common.close') }}</el-button>
        <el-button type="primary" @click="save(cronForm)">{{ $t('common.save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dataTableUtils from "@/utils/dataTableUtils";
import group from "@/api/system/group";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import cronApi from "@/api/system/cron";

export default {
  name: "categoryGroupList",
  extends: dataTableUtils,
  components: {IcSelect, PickupUser},
  created() {
    this.queryData();
  },
  data() {
    return {
      tableData: [],
      totalCount: null,
      queryCondition: {
        name: "",
        pageNum: 1,
        pageSize: 15
      },
      showSaveDialog: false,
      cronForm:{
        id:null,
        serviceName:null,
        cron:null,
        remark:null,
        name:null,
        lockMinuteMin:null,
        lockMinuteMax:null,
        disabledFlag:null,
        method:null,
      }
    };
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      cronApi.query(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    save(cron) {
      let that = this;
      cronApi.save(cron).then(res => {
        that.queryData();
      });
    },
    run(id) {
      cronApi.run(id).then(res => {
        Message.success(this.$t("common.operateSuccess"));
      })
    },
  }
}
</script>

<style scoped lang="scss">
.table {
  margin-top: 10px;
}

.cronForm {
  .el-input {
    width: 100%;
  }
}
</style>
